import {appConfig} from '~/config';

const API_HOST = appConfig.api.host;
const API_URL = appConfig.api.url;

export const ENDPOINTS = {
  CURRENT_USER: `user/me/detail`,
  FILE_UPLOAD: `app/file-uploads`,
  FILE_TEMPORARY_URL: `app/file-uploads/temporary-url`,
  QUESTIONNAIRES: `questionnaires`,
  MEDICAL_FORMS: `/app/medical-forms`,
  // MEDICAL_FORMS_2: `/admin/medical-forms/mdq2`,
  TESTIMONIALS: `app/testimonials`,
};
